import type { RouteLocation, RouteLocationNormalized } from "vue-router";

import { useEventBus } from "@/composables/useEventBus";
import type { ServerTime, TimerEvent } from "@/model/timer";
import { useBoardsStore } from "@/store/boards";
import { useSessionStore } from "@/store/session";
import { useTimerStore } from "@/store/timer";
import { useGlobalI18n } from "@/translations/i18n";
import Duration from "@/utils/Duration";

import { isBoardChange } from "./utils";

const { onServerTick } = useEventBus({ neverUnregister: true });

const { t } = useGlobalI18n();

let timer = "";
let place = "";

onServerTick((now) => {
  const newTimer = formatTimer(useTimerStore().lowestRunningTimer(now), now);
  if (newTimer !== timer) {
    timer = newTimer;
    setTitle();
  }
});

export function setDocTitle(to: RouteLocationNormalized, from: RouteLocationNormalized) {
  if (isBoardChange(from, to)) {
    const boardTitle = to.params.board ? useBoardsStore().boardTitle() : "";
    place = boardTitle || routeName(to);
    setTitle();
  }
}

function routeName(route: RouteLocation) {
  const selectedSession = useSessionStore().current;
  const title = route.meta?.title as string;
  return (title ? t(title.toString()) : "") + (selectedSession ? " - " + selectedSession.name : "");
}

function setTitle() {
  document.title = timer + place;
}

function formatTimer(timer: TimerEvent | undefined, now: ServerTime) {
  return timer ? Duration.fromEnd(timer.data.end, now).toString() + " " : "";
}
